export default class Collection {
    constructor(name, value, validation, description) {
        this.name = name;
        this.initialValue = value;
        this.value = value || [];
        this.description = description || 'file';
        this.validation = {
            required: validation && !!validation.required,
            error: null
        };
    }

    get hasChanged() {
        return this.initialValue !== this.value;
    }

    copy() {
        //return new Field(this.name, this.value, Object.assign({}, this.validation));
    }

    validate() {
        this.validation.error = null;
        if (this.validation.required && this.value.length < 1) {
            this.validation.error = `A ${this.description} is required`;
            return false;
        }

        return true;
    }

}